import AdminHeader from "../layout/AdminHeader";

const AppleWallet = () => {
  const handleAddToWallet = () => {
    // ✅ Safari के लिए anchor नहीं, direct redirect यूज़ करें
    window.location.href = "https://apiloyaltystaging.novusloyalty.com/web/api/passkit/novus-loyalty.pkpass";
  };

  return (
    <>
      <AdminHeader name={"Wallet"} />
      <div className="dashboard__content">
        <div className="container-fluid">
          <div style={{ textAlign: "center", marginTop: "5rem" }}>
            <button
              onClick={handleAddToWallet}
              style={{
                backgroundColor: "#000",
                color: "#fff",
                padding: "12px 48px",
                fontSize: "16px",
                fontWeight: "600",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Add to Apple Wallet
            </button>
          </div>
        </div>
      </div >
    </>
  );
};

export default AppleWallet;
